import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HiOutlineLockClosed, HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';
import { authAPI } from '../services/api';
import { getErrorMessage } from '../utils/errorHandler';
import toast from 'react-hot-toast';
import { IOSButton } from '../components/ios';

function MobileResetPassword() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (!tokenParam) {
      toast.error(t('resetPassword.invalidTokenRequest'));
      navigate('/login');
    } else {
      setToken(tokenParam);
    }
  }, [searchParams, navigate, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error(t('resetPassword.invalidToken'));
      return;
    }

    if (!newPassword || !confirmPassword) {
      toast.error(t('resetPassword.fillAllFields'));
      return;
    }

    if (newPassword.length < 6) {
      toast.error(t('resetPassword.passwordTooShort'));
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error(t('resetPassword.passwordsDontMatch'));
      return;
    }

    setLoading(true);
    try {
      await authAPI.resetPassword(token, newPassword);
      toast.success(t('resetPassword.passwordResetSuccess'));
      navigate('/login');
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-auth-page">
      {/* Header */}
      <div className="mobile-auth-header">
        <h1>My Series</h1>
        <p>{t('resetPassword.title')}</p>
      </div>

      {/* Formulário */}
      <form className="mobile-auth-form" onSubmit={handleSubmit}>
        <div className="mobile-auth-field">
          <label>{t('resetPassword.newPassword')}</label>
          <div className="mobile-auth-input-wrapper">
            <HiOutlineLockClosed className="mobile-auth-icon" />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder={t('resetPassword.enterNewPassword')}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={loading}
              minLength={6}
              required
            />
            <button
              type="button"
              className="mobile-auth-toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <HiOutlineEyeOff /> : <HiOutlineEye />}
            </button>
          </div>
        </div>

        <div className="mobile-auth-field">
          <label>{t('resetPassword.confirmNewPassword')}</label>
          <div className="mobile-auth-input-wrapper">
            <HiOutlineLockClosed className="mobile-auth-icon" />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder={t('resetPassword.confirmYourNewPassword')}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading}
              minLength={6}
              required
            />
          </div>
        </div>

        <IOSButton
          type="submit"
          variant="primary"
          fullWidth
          disabled={loading}
          className="mobile-auth-submit"
        >
          {loading ? t('resetPassword.resetting') : t('resetPassword.resetPassword')}
        </IOSButton>

        <button
          type="button"
          onClick={() => navigate('/login')}
          className="mobile-auth-link"
        >
          {t('resetPassword.backToLogin')}
        </button>
      </form>
    </div>
  );
}

export default MobileResetPassword;
